import { useSelector } from 'react-redux';
import FJCreationPanel from './FJCreationPanel';
import { useCallback } from 'react';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import FJActionModal from '../../../redux/action/FJActionModal';
import { useMemo } from 'react';
import FJConstant from '../../../constants/FJConstant';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJUtil from '../../../util/FJUtil.js';
import FJCommunityUtil from '../../../util/FJCommunityUtil.js';

const FJCreationPanelContainer = props => {
    useLocalStore();
    const {
        activeHeaderTabIndex = FJConstant.CREATIONS,

        hideCompare = false,

        isShowPresetImageBox = false,

        onRetry,

        bkColor,
        appType: propsAppType,
    } = props;
    const dispatch = useDispatch();

    const reduceAppType = useSelector(state => state.common.appType);
    const appType = propsAppType || reduceAppType;
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const presetList = useSelector(state => state.AIVideoGenerator.presetList);
    const presetImageList = useSelector(state => state.textToImage.presetImageList);
    const historyList = useSelector(state => state.common.historyList);

    const taskStatus = useSelector(state => {
        if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            return state.aiPhotoEditor.taskStatus;
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            return state.textToImage.taskStatus;
        } else if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            return state.imageToImage.taskStatus;
        } else {
            return state.common.taskStatus;
        }
    });

    const creationList = useSelector(state => {
        if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            return state.aiPhotoEditor.creationList;
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            return state.textToImage.creationList;
        } else if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            return state.imageToImage.creationList;
        } else {
            return state.common.creationList;
        }
    });

    const isShowFooter =
        !FJUtil.isGeneratingStatus(taskStatus) && taskStatus !== FJConstant.ERROR && creationList.length > 0;

    const hideDownload = useMemo(
        () =>
            taskStatus === FJConstant.ERROR ||
            appType === FJAppConstant.IMAGE_TO_IMAGE ||
            appType === FJAppConstant.WATERMARK_REMOVER,
        [taskStatus, appType],
    );

    const useHideCompare = useMemo(() => taskStatus === FJConstant.ERROR || hideCompare, [taskStatus, hideCompare]);

    const onDownload = useCallback(
        (id, callback) => {
            dispatch(FJActionCommon.multiDownloadAction([id], 'creation', callback, { previewList: creationList }));
        },
        [dispatch, creationList],
    );

    const onAddToMedia = url => {
        dispatch(FJActionEditPage.addToMediaLibraryAction(url, { from: 'generate' }));
    };

    const previewImage = data => {
        if (FJCommunityUtil.isUseNewPreviewModal(appType)) {
            const itemData = historyList.find(item => item.id === data.id);
            if (itemData) {
                dispatch(
                    FJActionModal.showDetailsPreviewModalDataAction({
                        data: { ...itemData, type: FJConstant.CREATIONS },
                    }),
                );
            }
        } else {
            dispatch(FJActionModal.showPreviewModalDataAction({ data }));
        }
    };

    const onPrivacySettingChange = (items, value, callback) => {
        dispatch(FJActionCommon.multiPrivacySettingChangeAction(items, value, callback));
    };

    const curCreationList = useMemo(() => {
        if (!isShowPresetImageBox) {
            // 物件擦除、舊照片修復、照片上色，创作区不需要显示图片
            if (
                // appType === FJAppConstant.OBJECT_ERASER ||
                appType === FJAppConstant.PHOTO_RESTORATION ||
                appType === FJAppConstant.PHOTO_COLORIZE
            ) {
                return creationList.map(item => {
                    return { ...item, isLoading: true };
                });
            }

            return creationList;
        }
        if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            return presetList.map(item => {
                return {
                    ...item,
                    width: 438,
                    height: 779,
                };
            });
        }
        return presetImageList.map(item => {
            return {
                ...item,
                width: 438,
                height: 779,
            };
        });
    }, [creationList, isShowPresetImageBox, presetImageList, presetList, appType]);

    const reGenerate = useCallback(
        id => {
            if (onRetry) onRetry(id);
            else dispatch(FJActionCommon.reGenerateAction(id));
        },
        [dispatch, onRetry],
    );

    const isShowBlankInVideoPanel =
        appType === FJAppConstant.IMAGE_TO_IMAGE ||
        appType === FJAppConstant.IMAGE_ENHANCER ||
        appType === FJAppConstant.FACE_SWAP ||
        appType === FJAppConstant.CLOTHES_CHANGER ||
        appType === FJAppConstant.AI_HAIRSTYLE_CHANGER ||
        appType === FJAppConstant.WATERMARK_REMOVER ||
        appType === FJAppConstant.OBJECT_ERASER ||
        appType === FJAppConstant.AI_PHOTO_EDITOR;

    return (
        <FJCreationPanel
            appType={appType}
            active={activeHeaderTabIndex === headerTabIndex}
            creationList={curCreationList}
            previewImage={previewImage}
            onDownload={onDownload}
            onAddToMedia={onAddToMedia}
            hideCompare={useHideCompare}
            hideDownload={hideDownload}
            isShowPresetImageBox={isShowPresetImageBox}
            isShowAddToMediaButton={false}
            reGenerate={reGenerate}
            isShowBlankInVideoPanel={isShowBlankInVideoPanel}
            bkColor={bkColor}
            isShowFooter={isShowFooter}
            onPrivacySettingChange={onPrivacySettingChange}
        />
    );
};

FJCreationPanelContainer.propTypes = {
    activeHeaderTabIndex: PropTypes.string,
    hideCompare: PropTypes.bool,
    isShowPresetImageBox: PropTypes.bool,
    onRetry: PropTypes.func,
    bkColor: PropTypes.string,
    appType: PropTypes.string,
};

export default FJCreationPanelContainer;
